import React, { useEffect, useRef } from "react";

export const usePureEffect = (func, dependencies) => {
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return () => {};
        }
        return func();
    }, dependencies);
};
